module.exports = __webpack_public_path__ + "media/images/cards-7cfc6bc639a48e986cc976888b7e1fb7.jpg";